function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

function viewport() {
    let viewport = 0;
    if (window.matchMedia('(min-width: 1440px)').matches) {
        viewport = 4;
    } else if (window.matchMedia('(min-width: 1200px)').matches) {
        viewport = 3;
    } else if (window.matchMedia('(min-width: 1024px)').matches) {
        viewport = 2;
    } else if (window.matchMedia('(min-width: 768px)').matches) {
        viewport = 1;
    }
    return viewport;
}